export default __webpack_public_path__ + "static/media/forestly-expl-dissect-07_EN.f88d082f.png";